import { render, staticRenderFns } from "./PlmnTableMenu.vue?vue&type=template&id=054e5a2d&scoped=true&"
import script from "./PlmnTableMenu.vue?vue&type=script&lang=js&"
export * from "./PlmnTableMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054e5a2d",
  null
  
)

export default component.exports